import { HttpResponse, HttpService } from '@application/http.service';
import type { AnswerApiModel, FormApiModel, FormGraphApiModel, FormOpportunity, RespondantApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_base_client';

export interface DynamicFormAnswer {
	boolValue: boolean | null;
	choices: Array<number>;
	intValue: number | null;
	questionId: number;
	stringValue: string | null;
}

export interface DynamicFormAnswers {
	completed: boolean;
	answers: DynamicFormAnswer[];
}

@Injectable()
export class DynamicFormsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('units');
	}

	public getAllForms(unitId: number, conditionId: number | null = null, opportunity: FormOpportunity | null = null) {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			conditionId,
			opportunity,
		});

		return this.httpService.get<FormApiModel[]>(`${this.baseUri}/${unitId}/forms/${parameterHandler.getString()}`);
	}

	public getById(unitId: number, id: number) {
		return this.httpService.get<FormGraphApiModel>(`${this.baseUri}/${unitId}/forms/${id}`);
	}

	public getRespondant(unitId: number, respondantId: number) {
		return this.httpService.get<RespondantApiModel>(`${this.baseUri}/${unitId}/forms/respondants/${respondantId}`);
	}

	public answer(unitId: number, respondantId: number, answers: DynamicFormAnswer[]): HttpResponse<unknown> {
		return this.httpService.post(
			`${this.baseUri}/${unitId}/forms/respondants/${respondantId}/answers`,
			answers.map(
				(answer) =>
					({
						BoolValue: answer.boolValue,
						IntValue: answer.intValue,
						Choices: answer.choices,
						QuestionId: answer.questionId,
						StringValue: answer.stringValue,
					}) satisfies AnswerApiModel,
			) as unknown as Record<string, string>,
		);
	}

	public setCompletion(unitId: number, respondantId: number): HttpResponse<unknown> {
		return this.httpService.post(`${this.baseUri}/${unitId}/forms/respondants/${respondantId}/completion`, null);
	}
}
